import type { AttentionItem } from '@/types/domain'

export type AttentionTone = 'brand' | 'attention' | 'negative' | 'neutral'

/* The tone of each «Требует решения» kind this build can label; the label
 * itself comes from the `dashboard.attention.kind` catalogue at render.
 *
 * The server computes `minus` and `stuck` only (S-2b.2). `approval` and
 * `payment-confirmation` LEFT this table when the rate approvals and the
 * payment-confirmation queue moved to «Мои задачи», in the strip above the
 * dashboard — and the table is what decides what a row may be: a kind with no
 * tone here is skipped (`knownAttention`). That is the deploy-window guard. A
 * server rolled back past S-2b.2 still sends both kinds, and this build has no
 * label and no sentence for either any more. */
export const KIND_TONES: Record<AttentionItem['kind'], AttentionTone> = {
  stuck: 'attention',
  minus: 'negative',
  overdue: 'negative',
  checklist: 'attention',
  'quote-followup': 'brand',
}

/** The tone for a served kind, or undefined for one this build cannot label.
 *  Takes a plain string because the wire can carry a kind the type does not
 *  admit. */
export function toneFor(kind: string): AttentionTone | undefined {
  return Object.hasOwn(KIND_TONES, kind)
    ? KIND_TONES[kind as AttentionItem['kind']]
    : undefined
}

/** The served rows this build can label, in the served order. The list renders
 *  exactly these, and the dashboard's subtitle counts exactly these, so the
 *  number in the sentence is the number of rows on screen. */
export function knownAttention(items: AttentionItem[]): AttentionItem[] {
  return items.filter((item) => toneFor(item.kind) !== undefined)
}
